import * as Classes from '../classes/models.classes';

export function patchReactionCountsOnPost(
  post: Classes.ShortsPosts | undefined | null,
  postId: number,
  counts: { Replies: number; Reposts: number; Likes: number }
): void {
  if (post?.TSID === postId && post.Reactions) {
    post.Reactions.Replies = counts.Replies;
    post.Reactions.Reposts = counts.Reposts;
    post.Reactions.Likes = counts.Likes;
  }
}

/** Apply server-pushed reaction counts without overwriting the current user's *Selected flags. */
export function patchReactionCountsInTree(
  posts: Classes.ShortsPosts[] | undefined | null,
  postId: number,
  counts: { Replies: number; Reposts: number; Likes: number }
): void {
  if (!posts?.length) {
    return;
  }
  for (const p of posts) {
    if (p.TSID === postId && p.Reactions) {
      p.Reactions.Replies = counts.Replies;
      p.Reactions.Reposts = counts.Reposts;
      p.Reactions.Likes = counts.Likes;
      return;
    }
    if (p.replies?.length) {
      patchReactionCountsInTree(p.replies, postId, counts);
    }
  }
}
